import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ScheduledAppointmentsResponse, ScheduledAppointmentsState } from "./index.types";

export const patientApiName = "patients";

export const initialSchduledAppointmetsStateValue: ScheduledAppointmentsState = {
  isLoading: false,
  isLoadingForSearch: false,
  isOverviewLoading: false,
  scheduleAppointmentsMessage: "",
  count: 0,
  next: null,
  previous: null,
  results: [],
  resultsForSearch: [],
  overviewResults: [],
};

export const scheduleAppointmentsSlice = createSlice({
  name: "patients",
  initialState: initialSchduledAppointmetsStateValue,
  reducers: {
    scheduleAppointments: (state) => {
      state.isLoading = true;
      state.scheduleAppointmentsMessage = "";
      state.results = [];
    },
    scheduleAppointmentsForSearch: (state) => {
      state.isLoadingForSearch = true;
    },
    scheduleAppointmentsOverview: (state) => {
      state.isOverviewLoading = true;
    },
    scheduleAppointmentsSuccess: (state, action: PayloadAction<ScheduledAppointmentsResponse>) => {
      state.isLoading = false;
      state.count = action.payload.count;
      state.next = action.payload?.next || null;
      state.previous = action.payload?.previous || null;
      state.results = action.payload?.results || [];
      state.scheduleAppointmentsMessage = action.payload?.results?.length === 0 ? "No Appointments found" : "";
    },
    scheduleAppointmentsForSearchSuccess: (state, action: PayloadAction<ScheduledAppointmentsResponse>) => {
      state.isLoadingForSearch = false;
      state.resultsForSearch = action.payload?.results || [];
    },
    scheduleAppointmentsOverviewSuccess: (state, action: PayloadAction<ScheduledAppointmentsResponse>) => {
      state.isOverviewLoading = false;
      state.overviewResults = action.payload?.results || [];
    },
    scheduleAppointmentsFail: (state) => {
      state.isLoading = false;
      state.count = 0;
      state.next = null;
      state.previous = null;
      state.results = [];
      state.scheduleAppointmentsMessage = "Sorry unable to get appointments";
    },
    scheduleAppointmentsForSearchFail: (state) => {
      state.isLoadingForSearch = false;
      state.resultsForSearch = [];
    },
    scheduleAppointmentsOverviewFail: (state) => {
      state.isOverviewLoading = false;
      state.overviewResults = [];
    },
    clearScheduleAppointmentsMessage: (state) => {
      state.scheduleAppointmentsMessage = "";
    },
  },
});

export const { scheduleAppointmentsSuccess, scheduleAppointmentsFail, clearScheduleAppointmentsMessage } =
  scheduleAppointmentsSlice.actions;

export default scheduleAppointmentsSlice.reducer;

const buildScheduledUrl = (
  pageNo: number,
  date: string,
  location_id?: string | number | null,
  practitioner_id?: string | number | null
): string => {
  const params: Record<string, string> = { date, page_size: "50", page: String(pageNo) };
  if (location_id) params.location_id = String(location_id);
  if (practitioner_id) params.practitioner_id = String(practitioner_id);
  return `/api/appointments/scheduled/?${new URLSearchParams(params).toString()}`;
};

export const getScheduledAppointments = (
  pageNo: number,
  date: string,
  location_id?: string | number | null,
  practitioner_id?: string | number | null
) => {
  return {
    payload: {
      apiName: patientApiName,
      method: "get",
      url: buildScheduledUrl(pageNo, date, location_id, practitioner_id),
    },
    type: "scheduleAppointments",
  };
};

export const getScheduledAppointmentsForSearch = (
  pageNo: number,
  date: string,
  location_id?: string | number | null,
  practitioner_id?: string | number | null
) => {
  return {
    payload: {
      apiName: patientApiName,
      method: "get",
      url: buildScheduledUrl(pageNo, date, location_id, practitioner_id),
    },
    type: "scheduleAppointmentsForSearch",
  };
};

export const getScheduledAppointmentsOverview = (
  data: any,
  pageNo: number,
  date: string,
  location_id?: string | number | null,
  practitioner_id?: string | number | null
) => {
  return {
    payload: {
      apiName: patientApiName,
      data,
      method: "get",
      url: buildScheduledUrl(pageNo, date, location_id, practitioner_id),
    },
    type: "scheduleAppointmentsOverview",
  };
};
